'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _common = require('../common');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TGSelect = function TGSelect(props) {
  var select = {
    id: (0, _common.useId)(),
    value: (0, _common.useValue)(props.value),
    focus: (0, _common.useFocus)(),
    touched: (0, _common.useTouched)(),
    autofill: (0, _common.useAutofill)()
  };

  var _onChange = function _onChange(e) {
    return props.onChange && props.onChange(e, e.target.value);
  };

  var _onBlur = function _onBlur(e) {
    return props.onBlur && props.onBlur(e, e.target.value);
  };

  var className = (0, _common.createClassName)('tg-select', {
    hasValue: select.value.hasValue,
    hasLabel: Boolean(props.label),
    hasFocus: select.focus.hasFocus,
    hasAutofill: select.autofill.hasAutofill,
    disabled: props.disabled,
    status: props.status
  });

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(props.className, className) },
    _react2.default.createElement(
      _common.Select,
      _extends({}, props, (0, _common.flatObj)(select), {
        onChange: function onChange(e) {
          select.value.onChange(e.target.value);
          _onChange(e);
        },
        onFocus: function onFocus() {
          select.focus.onFocus();
          select.touched.onFocus();
        },
        onBlur: function onBlur(e) {
          select.focus.onBlur();
          _onBlur(e);
        },
        leadingLane: [props.icon].filter(function (i) {
          return i;
        }),
        trailingLane: [_common.statusIcons[props.status]].filter(function (i) {
          return i;
        }) }),
      props.children
    ),
    _react2.default.createElement(
      'div',
      { className: 'tg-select__status-text' },
      props.statusText
    )
  );
};
TGSelect.Option = _common.Select.Option;
TGSelect.OptGroup = _common.Select.OptGroup;

exports.default = TGSelect;